import { UserResponse } from '../../models/auth.model';
import { UserRole } from '../constants/keys.constant';
import {
  ProfileStepsCompleted
} from '../constants/signUpStepper.const';
import { Router } from '@angular/router';

export function profileRouteNavigator(
  profile: UserResponse,
  router: Router,
  url: string = ''
): void {
  if (!profile) return;

  const { profileStepsCompleted, role } = profile;

  const ignoredUrls = [
    '/my-profile',
    '/manage-session',
    '/calendar',
    '/manage-tutoring',
    '/manage-counselling',
    '/manage-students',
    '/action-plan',
    '/manage-courses',
    '/support',
    '/manage-setting',
    '/manage-notification',
    '/dashboard/progress',
    '/chat'
  ];

  const urlShouldBeIgnored = ignoredUrls.some(path => url.includes(path));

  switch (profileStepsCompleted) {
  case ProfileStepsCompleted.InitialScreen:
    handleCaseForInitialScreen(profile, router);
    return;

  case ProfileStepsCompleted.InitialTutorCounsellorSelected:
  case ProfileStepsCompleted.TutorCounsellorPersonalDetailDone:
  case ProfileStepsCompleted.TutorCounsellorProfessionalDetailDone:
  case ProfileStepsCompleted.TutorCounsellorExpertiseDetailDone:
    router.navigate(['/auth/tutorCounsellor-profile-setup']);
    return;

  case ProfileStepsCompleted.TutorCounsellorProfileDone:
    // router.navigate(['/tutor/dashboard']);
    return;

  case ProfileStepsCompleted.InitialStudentParentSelected:
  case ProfileStepsCompleted.InitialStudentParentServiceInterestAdded:
  case ProfileStepsCompleted.StudentDetailsInitialAddedByStudent:
  case ProfileStepsCompleted.StudentFamilyDetailsEntered:
    router.navigate(['/auth/profile']);
    return;

  case ProfileStepsCompleted.StudentAcademicDetailsEntered:
  case ProfileStepsCompleted.SkippedAtStudentFamilyScreen:
  case ProfileStepsCompleted.SkippedAtStudentAcademicScreen:
  case ProfileStepsCompleted.ParentSkippedAtStudentDetail:
  case ProfileStepsCompleted.ParentSkippedAtAcademicDetail:
    if (!urlShouldBeIgnored) {
      router.navigate(['/dashboard']);
    }
    return;

  default:
    // eslint-disable-next-line no-case-declarations
    const defaultRoute = role === UserRole.TUTOR || role === UserRole.COUNSELOR ? '/tutor/dashboard' : '/dashboard';
    router.navigate([defaultRoute]);
      
  }
}


export function handleCaseForInitialScreen(
  profile: UserResponse,
  router: Router
): void {
  switch (profile.role) {
  case UserRole.TUTOR:
  case UserRole.COUNSELOR:
    router.navigate(['/auth/tutorCounsellor-profile-setup']);
    break;
  default: 
    router.navigate(['/auth/profile-setup']);
    break;
  }
}
